module.exports = __webpack_public_path__ + "img/price.821e00c0.svg";